"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ControlledSidebar = void 0;
var _faAngleLeft = require("@fortawesome/free-solid-svg-icons/faAngleLeft");
var _faBars = require("@fortawesome/free-solid-svg-icons/faBars");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _classnames = _interopRequireDefault(require("classnames"));
var _lodash = require("lodash");
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _theme = require("../../../theme");
var _components = require("./components");
var _context = require("./context");
var _Sidebar = require("./Sidebar.styles");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var SidebarComponent = function SidebarComponent(props) {
  var locale = props.locale,
    locales = props.locales,
    onChangeLocale = props.onChangeLocale,
    items = props.items,
    zIndex = props.zIndex,
    children = props.children,
    _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className,
    appName = props.appName,
    _props$showLogo = props.showLogo,
    showLogo = _props$showLogo === void 0 ? true : _props$showLogo,
    _props$showLabel = props.showLabel,
    showLabel = _props$showLabel === void 0 ? true : _props$showLabel,
    _props$hasMouseHandle = props.hasMouseHandler,
    hasMouseHandler = _props$hasMouseHandle === void 0 ? true : _props$hasMouseHandle,
    _props$showOpenButton = props.showOpenButton,
    showOpenButton = _props$showOpenButton === void 0 ? true : _props$showOpenButton,
    _props$type = props.type,
    type = _props$type === void 0 ? 'static' : _props$type;
  var rootRef = (0, _react.useRef)(null);
  var _useContext = (0, _react.useContext)(_context.SidebarContext),
    isOpen = _useContext.isOpen,
    toggle = _useContext.toggle,
    setRollUp = _useContext.setRollUp,
    rollUp = _useContext.rollUp,
    close = _useContext.close;
  var classes = (0, _Sidebar.useStyles)({
    type: type
  });
  var _useTheme = (0, _theme.useTheme)(),
    _useTheme$images = _useTheme.images,
    logo = _useTheme$images.logo,
    fullLogo = _useTheme$images.fullLogo;
  var handleMouseEnter = (0, _react.useMemo)(function () {
    return (0, _lodash.debounce)(function () {
      return setRollUp(true);
    }, 300);
  }, [setRollUp]);
  var handleMouseLeave = (0, _react.useCallback)(function (e) {
    if (rootRef.current && e.relatedTarget.nodeName && rootRef.current.contains(e.relatedTarget)) {
      return;
    }
    handleMouseEnter.cancel();
    setRollUp(false);
  }, [setRollUp, rootRef, handleMouseEnter]);
  var expanded = rollUp || isOpen;
  var hasMouseHandlerCb = (0, _react.useCallback)(function (fn) {
    return hasMouseHandler ? fn : undefined;
  }, [hasMouseHandler]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("aside", {
    ref: rootRef,
    className: (0, _classnames["default"])(classes.root, className, _defineProperty({}, classes.opened, isOpen))
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.mainWrapper,
    style: {
      zIndex: zIndex
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    onMouseEnter: hasMouseHandlerCb(handleMouseEnter),
    onMouseLeave: hasMouseHandlerCb(handleMouseLeave),
    className: (0, _classnames["default"])(classes.mainHolder, _defineProperty(_defineProperty({}, classes.opened, isOpen), classes.rollup, rollUp))
  }, showLogo && /*#__PURE__*/_react["default"].createElement(_reactRouterDom.NavLink, {
    to: "/",
    className: (0, _classnames["default"])(classes.logo, _defineProperty({}, classes.logoExpanded, expanded))
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.logoHolder
  }, /*#__PURE__*/_react["default"].createElement("img", {
    alt: "logo",
    src: expanded ? fullLogo : logo
  }), expanded && /*#__PURE__*/_react["default"].createElement("h1", null, appName))), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.content
  }, /*#__PURE__*/_react["default"].createElement("nav", {
    className: classes.nav
  }, /*#__PURE__*/_react["default"].createElement(_components.AppMenu, {
    items: items,
    showLabel: showLabel
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.tools
  }, children, locale && /*#__PURE__*/_react["default"].createElement(_components.LocalePicker, {
    onChangeLocale: onChangeLocale,
    locale: locale,
    locales: locales
  })))), showOpenButton && /*#__PURE__*/_react["default"].createElement("span", {
    onClick: toggle,
    className: classes.toggleButton,
    onMouseLeave: hasMouseHandlerCb(handleMouseLeave)
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: isOpen ? _faAngleLeft.faAngleLeft : _faBars.faBars
  })))), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(classes.overlay, isOpen ? classes.openOverlay : ''),
    onClick: close
  }));
};
var ControlledSidebar = function ControlledSidebar(props) {
  return /*#__PURE__*/_react["default"].createElement(SidebarComponent, props);
};
exports.ControlledSidebar = ControlledSidebar;